import React from 'react';
import {Container, Grid, IconButton} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import {footerData} from '../../values';

import {useStyles} from '../global/styles';
const Footer = () => {
    const classes = useStyles()
    const history = useHistory()
    const Contact = () =>{
        history.push('/contact')
    }
    const Privacy = () =>{
        history.push('/privacy')
    }
    const Instagram = () =>{
        window.open(footerData.link)
    }
    return (
        <div style={{minHeight:210, background:'black'}}>
            <Container maxWidth="xl">
                <div style={{height:50}} />
                <Grid container>
                    <Grid item sm={6}>
                        <div style={{marginLeft:50}}>
                            <div style={{paddingBottom:20}}>
                                <img alt="Rayas Logo" src={footerData.image} style={{width:100, cursor:'pointer'}} onClick={() => history.push('/')} />
                            </div>
                            <label className={classes.text} style={{ fontSize:12}}>{footerData.text1}</label>
                        </div>
                    </Grid>
                    <Grid item sm={6}>
                        <div style={{display:'flex', justifyContent:'flex-end'}}>
                            <div style={{marginRight:50}}>
                                <div style={{paddingBottom:5}}>
                                    <label className={classes.text} style={{ fontSize:26, fontWeight:600, fontFamily:'Heavy',}}>{footerData.text2}</label>
                                </div>
                                <label 
                                    onClick={Privacy}
                                    className={classes.text} style={{ fontSize:14, fontWeight:600, cursor:'pointer'}}>
                                        {footerData.text3}
                                </label><br/>
                                <label 
                                    onClick={Contact}
                                    className={classes.text} style={{ fontSize:14, fontWeight:600, cursor:'pointer'}}>
                                        {footerData.text5}
                                </label>
                                <br/>
                                <div style={{display:'flex',alignItems:'center', marginLeft:-10}}>
                                    <IconButton onClick={Instagram}>
                                        <img alt="Instagram Icon" src={footerData.icon} />
                                    </IconButton>
                                    <label className={classes.text} style={{ fontSize:14, fontWeight:600}}>{footerData.text4}</label>
                                </div>

                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default Footer;